import { ParsedUrlQuery } from 'querystring'
import { logger } from '../logging'

/**
 * @param url the fully formed URL, cannot be relative
 * @param extraQueryParams
 */
export const mergeQueryParameters = (
  url: string,
  extraQueryParams: ParsedUrlQuery | Record<string, string>,
): string => {
  try {
    const urlObject = new URL(url)
    Object.entries(extraQueryParams).forEach(([key, value]) => {
      if (!urlObject.searchParams?.get(key)) {
        urlObject.searchParams.append(key, value as string)
      }
    })

    return urlObject.toString()
  } catch (error) {
    logger().error('Error merging query params', { url, extraQueryParams, error })
    return url
  }
}

export const mergeUrlParams = (url: string, additionalParams: Record<string, string> = {}): string => {
  try {
    if (typeof window === 'undefined') return url

    const currentParams = new URLSearchParams(window.location.search)
    const newUrl = new URL(url, window.location.origin)

    // Merge current URL parameters into the new URL
    currentParams.forEach((value, key) => {
      newUrl.searchParams.set(key, value)
    })

    // Add additional parameters to the new URL
    Object.entries(additionalParams).forEach(([key, value]) => {
      newUrl.searchParams.set(key, value)
    })

    return newUrl.toString()
  } catch (error) {
    logger().error('Error merging query params', { url, additionalParams, error })
    return url
  }
}
